// Shared constants and helpers for Booking module

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Auth header helper
export const getAuthHeader = () => {
  const token = localStorage.getItem('access_token') || localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

// Validation helpers
export const validatePAN = (pan) => {
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return !pan || panRegex.test(pan);
};

export const validateGST = (gst) => {
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  return !gst || gstRegex.test(gst);
};

export const validateAadhar = (aadhar) => {
  const aadharRegex = /^[0-9]{12}$/;
  return !aadhar || aadharRegex.test(aadhar);
};

export const validateMobile = (mobile) => {
  const mobileRegex = /^[6-9][0-9]{9}$/;
  return !mobile || mobileRegex.test(mobile);
};

// Initial form state for new bookings
export const getInitialFormData = () => ({
  // Customer Details
  salutation: 'Mr',
  customer_first_name: '',
  customer_last_name: '',
  father_husband_name: '',
  dob: '',
  gender: 'Male',
  mobile_no_1: '',
  mobile_no_2: '',
  whatsapp_no_1: '',
  email: '',
  building_name: '',
  door_no: '',
  address_1: '',
  address_2: '',
  area: '',
  city: '',
  state: '',
  pin_code: '',
  aadhar_no: '',
  pan_no: '',
  gst_no: '',

  // Vehicle Details
  vehicle_selection: 'New',
  vehicle_type: '4 wheeler',
  usage: 'Personal',
  brand_name: '',
  model: '',
  variant: '',
  color: '',
  fuel_type: 'Petrol',
  chassis_no: '',
  engine_motor_no: '',
  charger_no: '',
  battery_no: '',
  controller_no: '',
  key_no: '',

  // Insurance
  insurance_company_name: '',
  type_of_insurance: 'comprehensive',
  policy_no: '',
  policy_status: 'Not Received',
  gross_premium: 0,
  net_premium: 0,
  own_damage_expiry_date: '',
  third_party_expiry_date: '',
  insurance_nominee_name: '',
  relationship: 'son',
  nominee_dob: '',

  // Registration
  rto_area: '',
  rto_code: '',
  rto_broker_name: '',
  rto_mobile_no: '',
  rto_paper_status: 'pending',
  registration_number: '',
  date_of_registration: '',
  rc_status: 'pending',
  hsrp_number_plate: 'pending',
  hsrp_received_informed: 'No',
  hsrp_informed_date: '',

  // Accessories
  accessories: {},
  accessories_total: 0,

  // Accounting Details
  invoice_dms: '',
  dms_invoice_no: '',
  dms_invoice_date: '',
  tally_invoice: '',
  customer_balance: 0,
  ledger_status: 'pending',
  accounts_verified_by: '',
  financiers_payment_status: 'pending',
  pool_amount: 0,
  scheme_discount_1: 0,
  scheme_discount_2: 0,
  special_discount: 0,

  // Exchange Vehicle
  exchange_vehicle_no: '',
  ex_brand_name: '',
  ex_model_name: '',
  ex_variant_name: '',
  ex_color: '',
  year_of_manufacturing: '',
  exchange_value: 0,
  inwards_status: 'Inwards Pending',
  date_of_delivery: '',
  traffic_challans_pending: 0,

  // Booking Details
  booking_through: 'Direct',
  date_of_booking: new Date().toISOString().split('T')[0],
  sales_representative: '',
  delivery_date: '',
  lead_source: '',
  address_proof: '',
  address_proof_received: 'Not Received',
  photos: 'pending',

  // Finance Details
  financiers_name: '',
  financiers_address_1: '',
  financiers_address_2: '',
  financiers_area: '',
  financiers_city: '',
  financiers_state: '',
  financiers_pincode: '',
  financiers_mobile_no: '',
  date_of_disbursement: '',
  disbursement_amount: 0,
  loan_status: 'pending',
  loan_account_no: '',
  emi_amount: 0,
  tenure_months: 0,
  rate_of_interest: 0,

  // PME Drive
  pme_drive_no: '',
  pme_submission_date: '',
  pme_status: 'pending',
  pme_remarks: '',

  // Sellers Details
  sellers_name: '',
  sellers_father_name: '',
  sellers_phone_1: '',
  sellers_phone_2: '',
  sellers_email: '',
  sellers_address_1: '',
  sellers_address_2: '',
  sellers_area: '',
  sellers_city: '',
  sellers_state: '',
  sellers_pincode: '',
  sellers_aadhar: '',
  sellers_pan: '',

  // Agent Details
  agents_name: '',
  agents_father_name: '',
  agents_phone_1: '',
  agents_phone_2: '',
  agents_email: '',
  agents_address_1: '',
  agents_address_2: '',
  agents_area: '',
  agents_city: '',
  agents_state: '',
  agents_pincode: '',
  agents_commission: 0,

  // Vendor Details
  vendors_name: '',
  vendors_phone_1: '',
  vendors_phone_2: '',
  vendors_email: '',
  vendors_address_1: '',
  vendors_address_2: '',
  vendors_area: '',
  vendors_city: '',
  vendors_state: '',
  vendors_pincode: '',
  vendors_gst: '',
});
